<template>
    <div class="label" :style="{'--label-color': value.color}" :class="{'active': isActive}" @click="$emit('click')" > 
        <div style="display: flex; width: 100%; height: 36px; padding: 0 3px 0 6px; align-items: center; justify-content: space-between;">
            <input type="text" :value="value.name" @input="value.setName($event.target.value)" style="width: 110px;">
            <div style="display: flex; gap: 5px; max-height: 100%; align-items: center;">
                <div class="count">
                    {{ count }}
                </div>
                <button @click="$emit('delete')">DEL</button>
            </div>
        </div>
        <div class="colorBoard" v-show="isActive" @mousedown.stop>
            Color
            <div style="display: flex; flex-wrap: wrap; gap: 6px;">
                <div class="color" :class="{selected: color == value.color}" @click="value.setColor(color);" :style="{'--button-color': color}" v-for="color in colors" :key="color"></div>
            </div>
        </div>
    </div>
</template>

<script>
import { ObjectDetectionClass, ObjectDetectionColor } from '../../scripts/ObjectDetection.js';

export default{
    emits: ['click', 'delete'],
    props: {
        value: {
            type: ObjectDetectionClass,
        },
        isActive: {
            type: Boolean, 
            default: false
        },
        count: {
            type: Number,
            default: 0
        }
    },
    data(){
        return {
            showColor: false,
            colors: ObjectDetectionColor,
        }
    }
}
</script>

<style scoped>
.label{
    width: 100%;
    height: max-content;
    color: #fff;
    box-sizing: border-box;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    border-radius: 5px;
    padding: 1px;
    /* transition: .3s background ease-in-out; */
    /* filter: grayscale(100%); */

    border: 2px solid var(--label-color);
    background: #fff;
    gap: 1px;

}
.label:hover, .label.active{
    background: var(--label-color);
}
.label input{
    outline: none;
    border: none;
    padding: 3px;
    background: #fff;
    color: var(--label-color);
}
.label:not(.active) input{
    pointer-events: none;
}
.label:hover input, .label.active input{
    background: var(--label-color);
    color: white;
}
.label.active input{
    border-bottom: 1px solid white;
}

.count{
    width: 24px; height: 24px; 
    border: 2px solid var(--label-color);
    color: var(--label-color);
    display: flex; justify-content: center; align-items: center; 
    font-weight: 600; font-size: 10px;
}

.label:hover .count ,.label.active .count{
    border-color: #fff;
    color: #fff;
}


.colorBoard{
    width: 100%; 
    height: max-content;
    background: white;
    border-radius: 0;
    color: var(--label-color);
    padding: 5px;
    cursor: default;
    display: flex;
    flex-direction: column;
    gap: 5px;
    font-weight: 600;
}

.color{
    width: 30px; height: 20px;
    border: 2px solid var(--button-color);
    cursor: pointer;
    border-radius: 3px;
}

.color.selected{
    background-color: var(--button-color);
}

.color:hover{
    background: var(--button-color);
}


button{
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 2px solid var(--label-color);
    color: var(--label-color);
    font-weight: 600;
    background: white;
    max-height: 100%;
    padding: 1px;
    height: 26px;
    width: 26px;
    font-size: 8px;
    border-radius: 3.5px;
}

button:hover{
    background: var(--label-color);
    color: white;
    border-color: #fff;
}

button img{
    width: 100%;
}


</style>